<template>
  <div class="intro-wrapper">
     <nav-common :nav="nav"></nav-common>
    <div class="intro-conent">
      <div class="intro-inner">
        <item-detail v-if="detail&&detail.is_file =='0'" :detail="detail"></item-detail>
        <file-down v-if="detail&&detail.is_file =='1'" :detail="detail"></file-down>
      </div>
    </div>
  </div>
</template>
<style scoped>
.intro-conent {
  width: flex;
  background: #e6ecf2;
  padding: 20px 0;
  border: 1px solid #e6ecf2;
  border-radius: 10px;
  box-sizing: border-box;
}
.intro-inner {
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import fileDown from "@/components/views/common/fileDown.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      seconTitle: "",
      detail: {},
                  nav: {
        firsttitle: this.$route.query.type==1?'海洋标准化':this.$route.query.type==2?'海洋计量':'海洋质量监督',
        firstrouteName: "BusinessIntro",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
    };
  },
  methods: {
    getDetail() {
      userApi.workDetail({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
        if(res.data){
          this.nav.secondtitle = res.data.workname;
        }
      });
    }
  },
  mounted() {
    this.getDetail();
  },
  watch: {
    $route(val, oldval) {
      this.getDetail();
    }
  },
  components: {
    navCommon,
    itemDetail,
    fileDown
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/businessWork/Children/detail.vue